const Index = () => import(/* webpackChunkName: "parkproject" */ './Index');
// const View = () => import(/* webpackChunkName: "made-in-china-2025" */ './View');
// const ViewAll = () => import(/* webpackChunkName: "made-in-china-2025" */ './ViewALl');

export default {
  routes: [
    {
      path: '/park/v2019/index',
      name: 'parkV2019Index',
      component: Index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/parkproject/v2019/router.js